module.exports = __webpack_public_path__ + "img/iran.be7d471b.svg";